export default __webpack_public_path__ + "912bc22fc20c4a6df813a9865217e1ff.png";